import type { NitroFetchOptions, NitroFetchRequest } from 'nitropack'
import { queryOptions } from '@tanstack/vue-query'
import type { FeaturedProductsConfigPayloadDTO } from '~/types/api/bff/web/featured-products/featured-products.types'

export const useGetFeaturedProductsQuery = (
  payloadRef: MaybeRefOrGetter<FeaturedProductsConfigPayloadDTO>,
  options?: NitroFetchOptions<NitroFetchRequest>
) => {
  const { $featuredProductRepository } = useNuxtApp()

  return queryOptions({
    queryKey: ['featured-products', payloadRef],
    queryFn: async () => {
      const payload = unref(payloadRef) as FeaturedProductsConfigPayloadDTO
      try {
        return await $featuredProductRepository.create(payload, unref(options))
      } catch (error) {
        useBugsnag().notify(
          {
            name: 'Featured Products Carousel',
            message: error?.toString() || 'Failed to fetch featured products',
            cause: error,
          },
          event => {
            event.addMetadata('featured-product-meta', payload)
          }
        )
        throw error
      }
    },
  })
}
